import React from 'react';
import { formatCurrency } from '../../lib/helpers/formatters';
import { FEE_ELETTRIC, POLIS_FEE_FIXED } from '../../App';

function CurrencyFieldCentMc({ value, data }) {
  const energy_contract = data?.energy_contract || {};
  const contract_value = data?.contract_value || 0;
  const sub = contract_value - (energy_contract.initial_fixed_value || 0);
  if (typeof Number(sub) !== 'number') return <>{formatCurrency(0)}</>;
  if ([...FEE_ELETTRIC, ...POLIS_FEE_FIXED].includes(data?.product_name))
    return <>{formatCurrency(0)}</>;

  return <>{formatCurrency(sub)}</>;
}

export default CurrencyFieldCentMc;
